import { Injectable } from '@angular/core';

declare var grecaptcha: any;

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {

  private v2Loaded = false;
  private v3Loaded = false;

  constructor() { }

  // ─────────────────────────────────────────────
  //   CARGAR SCRIPT DINÁMICO
  // ─────────────────────────────────────────────

  private loadScript(id: string, src: string): Promise<void> {
    return new Promise((resolve, reject) => {	
      if (document.getElementById(id)) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.id = id;
      script.src = src;
      script.onload = () => resolve();
      script.onerror = () => reject(`Error loading script ${src}`);

      document.body.appendChild(script);
    });
  }

  public limpiarRecaptchaV3() {
    // 1. Borrar badge
    document.querySelectorAll('.grecaptcha-badge')
      .forEach(el => el.remove());

    // 2. Borrar script
    const script = document.getElementById('recaptcha-v3');
    if (script) {
      script.remove();
    }

    // 3. Borrar referencia global
    // @ts-ignore
    // delete window.grecaptcha;

    // 4. Resetear estado interno
    this.v3Loaded = false;
    // this.v2Loaded = false;
  }

  // ─────────────────────────────────────────────
  //   reCAPTCHA V3
  // ─────────────────────────────────────────────
  loadRecaptchaV3(siteKey: string): Promise<void> {
    return this.loadScript(
      'recaptcha-v3',
      `https://www.google.com/recaptcha/api.js?render=${siteKey}`
    ).then(() => {
      this.v3Loaded = true;
    });
  }

  executeRecaptchaV3(siteKey: string, actionStr = 'default'): Promise<string> {
    return new Promise(async (resolve, reject) => {
      if (!this.v3Loaded) {
        await this.loadRecaptchaV3(siteKey);
      }

      grecaptcha.ready(() => {
        grecaptcha.execute(siteKey, { action: actionStr })
          .then((token: string) => resolve(token))
          .catch((err: any) => reject(''));
      });
    });
  }

  // ─────────────────────────────────────────────
  //   reCAPTCHA V2 (visible)
  // ─────────────────────────────────────────────
  async generarTokenCaptchaV2(siteKey: string, containerId: string): Promise<string> {
    await this.loadRecaptchaV2();

    return new Promise<string>((resolve) => {
      grecaptcha.render(containerId, {
        sitekey: siteKey,
        callback: (token: string) => resolve(token),
        'error-callback': () => resolve('')
      });
    });
  }

  async generarTokenCaptchaV3(siteKey: string, actionStr: string,): Promise<string> {
    return new Promise<string>((resolve) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(siteKey, { action: actionStr })
          .then((token: string) => resolve(token))
          .catch((err: any) => resolve('error'));
      });
    });
  }



  // ─────────────────────────────────────────────
  //   reCAPTCHA V2 (invisible / hidden)
  // ─────────────────────────────────────────────
  async renderRecaptchaV2Hidden(containerId: string, siteKey: string): Promise<any> {
    await this.loadRecaptchaV2();

    const widgetId = grecaptcha.render(containerId, {
      sitekey: siteKey,
      size: 'invisible',
      callback: (token: string) => console.log("token invisible", token)
    });

    // ocultar contenedor
    const el = document.getElementById(containerId);
    if (el) el.style.display = 'none';

    return widgetId;
  }

  // ─────────────────────────────────────────────
  //   CARGA reCAPTCHA V2
  // ─────────────────────────────────────────────
  public async loadRecaptchaV2(): Promise<void> {
    if (!this.v2Loaded) {
      this.limpiarRecaptchaV3();
      await this.loadScript(
        'recaptcha-v2',
        'https://www.google.com/recaptcha/api.js'
      );
      //this.crearContenedorCaptcha();
      this.v2Loaded = true;
    } else {
      this.crearContenedorCaptcha();
    }

  }



  crearContenedorCaptcha() {
    const boxes = document.getElementById('captchaDiv');
    if (boxes) {
      document.getElementById("recaptcha-container").remove();
      let div = document.createElement('div')
      div.setAttribute('id', "recaptcha-container");
      //div.setAttribute('required','required');
      boxes.appendChild(div);
    }
    //this.setupRecaptcha();
  }

  // ─────────────────────────────────────────────
  //   RESET V2
  // ─────────────────────────────────────────────
  reset(widgetId: number) {
    if (grecaptcha) {
      grecaptcha.reset(widgetId);
    }
  }

}